module.exports = __webpack_public_path__ + "img/portraits_13_V.c7b2ccd6.jpg";